import api from "./apiBase";

const MODULE = "printer-queue-items";

function getPrinterQueue({ page = 1, limit = 10, filter, search } = {}) {
  return api.get(`${MODULE}`, {
    params: {
      page,
      limit,
      filter,
      search,
    },
  });
}

function getPrinterQueueItemById(id) {
  return api.get(`${MODULE}/${id}`);
}

function getPrinterQueueByPrinter(
  printerUserId,
  { page = 1, limit = 10, filter, search } = {},
) {
  return api.get(`${MODULE}/printer/${printerUserId}`, {
    params: {
      page,
      limit,
      filter,
      search,
    },
  });
}

function getCurrentPrinterQueueItem(printerUserId) {
  return api.get(`${MODULE}/printer/${printerUserId}/current`);
}

function createPrinterQueueItem(data) {
  return api.post(`${MODULE}`, data);
}

function updatePrinterQueueItem(id, data) {
  return api.patch(`${MODULE}/${id}`, data);
}

function startPrinterQueueItem(id) {
  return api.patch(`${MODULE}/${id}/start`);
}

function updatePrinterQueueProgress(id, data) {
  return api.patch(`${MODULE}/${id}/progress`, data);
}

function finishPrinterQueueItem(id, data) {
  return api.patch(`${MODULE}/${id}/finish`, data);
}

function failPrinterQueueItem(id, data) {
  return api.patch(`${MODULE}/${id}/fail`, data);
}

function cancelPrinterQueueItem(id) {
  return api.patch(`${MODULE}/${id}/cancel`);
}

function reorderPrinterQueueItem(id, data) {
  return api.patch(`${MODULE}/${id}/reorder`, data);
}

export {
  getPrinterQueue,
  getPrinterQueueItemById,
  getPrinterQueueByPrinter,
  getCurrentPrinterQueueItem,
  createPrinterQueueItem,
  updatePrinterQueueItem,
  startPrinterQueueItem,
  updatePrinterQueueProgress,
  finishPrinterQueueItem,
  failPrinterQueueItem,
  cancelPrinterQueueItem,
  reorderPrinterQueueItem,
};
